import { createContext } from 'react';

interface ContextValue {
  setContentEl: (portalId: string, contentEl: HTMLElement) => void;
  removeContentEl: (portalId: string) => void;
  contentEls: { [portalId: string]: HTMLElement | null };
}

export default createContext<ContextValue | null>(null);
